import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/paramount/paramount/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "contributing"
    }}>{`Contributing`}</h1>
    <h2 {...{
      "id": "pull-requests"
    }}>{`Pull requests`}</h2>
    <p>{`Follow this process if you'd like your work considered for inclusion in the project:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://help.github.com/fork-a-repo/"
          }}>{`Fork`}</a>{` the project, clone your fork, and configure the remotes:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`git clone https://github.com/<your-username>/paramount
cd paramount
git remote add upstream https://github.com/WeTrustPlatform/paramount
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If you cloned a while ago, get the latest changes from upstream:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`git checkout master
git pull upstream master
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Install/update dependencies:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`yarn install
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Create a new topic branch (off the `}<inlineCode parentName="p">{`master`}</inlineCode>{` branch) to
contain your feature, change, or fix:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`git checkout -b <topic-branch-name>
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Locally merge (or rebase) the upstream development branch into your topic branch:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`git pull [--rebase] upstream master
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Push your topic branch up to your fork:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`git push origin <topic-branch-name>
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://help.github.com/articles/using-pull-requests/"
          }}>{`Open a Pull Request`}</a>{`
with a clear title and description. If screenshot can be included, please attach one.`}</p>
      </li>
    </ol>
    <h2 {...{
      "id": "development-for-react-native"
    }}>{`Development for React Native`}</h2>
    <p>{`N/A`}</p>
    <h2 {...{
      "id": "development-for-react-web"
    }}>{`Development for React Web`}</h2>
    <p>{`The development of components on web happen on Storybook`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn dev
`}</code></pre>
    <p>{`Storybook will then be available at `}<a parentName="p" {...{
        "href": "http://localhost:6006"
      }}>{`http://localhost:6006`}</a>{`.`}</p>
    <h2 {...{
      "id": "development-for-docs"
    }}>{`Development for Docs`}</h2>
    <p>{`The development of components on web happen on the documentation site`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn docs
`}</code></pre>
    <p>{`Docz will then be available at `}<a parentName="p" {...{
        "href": "http://localhost:3000"
      }}>{`http://localhost:3000`}</a>{`.`}</p>
    <h2 {...{
      "id": "running-tests"
    }}>{`Running Tests`}</h2>
    <p>{`You can run unit tests with like so:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn test
`}</code></pre>
    <p>{`If you are confident in your changes, update snapshots`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`  yarn test -u
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      